import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Menu data
  menuItems: [],
  menuLoading: false,
  menuError: null,
  menuDate: null,
  menuTitle: '',

  // Cart - items user has selected with quantities
  cart: {}, // { menuItemId: { item, quantity } }

  // Customer info
  customerInfo: {
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    notes: '',
    pickupTime: '',
  },

  // Order
  order: null, // { TiffinOrder_Id, TotalAmount, PaymentStatus }
  orderLoading: false,
  orderError: null,

  // Order detail (after payment)
  orderDetail: null,
};

const tiffinSlice = createSlice({
  name: 'tiffin',
  initialState,
  reducers: {
    // Menu
    setMenuItems: (state, action) => {
      state.menuItems = action.payload;
      state.menuError = null;
      if (action.payload.length > 0) {
        state.menuDate = action.payload[0].menuDate;
        state.menuTitle = action.payload[0].menuTitle || '';
      }
    },
    setMenuLoading: (state, action) => {
      state.menuLoading = action.payload;
    },
    setMenuError: (state, action) => {
      state.menuError = action.payload;
    },

    // Cart
    addToCart: (state, action) => {
      const item = action.payload;
      const id = item.tiffinMenuItem_Id;
      if (state.cart[id]) {
        state.cart[id].quantity += 1;
      } else {
        state.cart[id] = { item, quantity: 1 };
      }
    },
    removeFromCart: (state, action) => {
      const id = action.payload;
      if (state.cart[id]) {
        if (state.cart[id].quantity > 1) {
          state.cart[id].quantity -= 1;
        } else {
          delete state.cart[id];
        }
      }
    },
    setCartItemQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      if (quantity <= 0) {
        delete state.cart[id];
      } else if (state.cart[id]) {
        state.cart[id].quantity = quantity;
      }
    },
    clearCart: (state) => {
      state.cart = {};
    },

    // Customer info
    setCustomerInfo: (state, action) => {
      state.customerInfo = { ...state.customerInfo, ...action.payload };
    },

    // Order
    setOrder: (state, action) => {
      state.order = action.payload;
      state.orderError = null;
    },
    setOrderLoading: (state, action) => {
      state.orderLoading = action.payload;
    },
    setOrderError: (state, action) => {
      state.orderError = action.payload;
    },

    // Order detail
    setOrderDetail: (state, action) => {
      state.orderDetail = action.payload;
    },

    // Reset all tiffin state
    resetTiffin: () => initialState,
  },
});

export const {
  setMenuItems,
  setMenuLoading,
  setMenuError,
  addToCart,
  removeFromCart,
  setCartItemQuantity,
  clearCart,
  setCustomerInfo,
  setOrder,
  setOrderLoading,
  setOrderError,
  setOrderDetail,
  resetTiffin,
} = tiffinSlice.actions;

export default tiffinSlice.reducer;
